import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tw-space-y-3" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "tw-text-base sm:tw-text-lg tw-font-semibold tw-text-slate-900"
}
const _hoisted_4 = { class: "tw-relative tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white/60 tw-shadow-sm" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isShowTitle)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "Vessel Tracking"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        class: "tw-absolute tw-top-0 tw-left-0 tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/100 hover:tw-bg-grey tw-px-1 tw-py-1 tw-text-sm tw-font-medium tw-text-slate-800 tw-transition tw-duration-150",
        href: _ctx.vesselTrackerExternalUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, " Track on VesselFinder.com (MMSI " + _toDisplayString((this as any).mssi) + ") ", 9, _hoisted_5),
      _createElementVNode("iframe", {
        name: "vesselfinder",
        id: "vesselfinder",
        class: "tw-block tw-w-full",
        style: _normalizeStyle({ height: _ctx.computedHeight }),
        frameborder: "0",
        src: _ctx.vesselTrackerUrl
      }, null, 12, _hoisted_6)
    ])
  ]))
}